export default __webpack_public_path__ + "static/media/514.52976ce1.png";